declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { ActorEmploymentPreferencesRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, GuardianInfoRequest, SaveGuardianInfoRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, BillPaymentOption, NewBillData, SaveBillItemsInfoRequest, SaveIPBillItemsInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchPatientModal } from '../../follow up/counsellingregistry/modal/searchpatient.modal';
import { CodeTypeValue, CodeTypeRequest } from '../../../../custumcomponents/codetypes/codetypevalue.interface';
import { CodeTypeValueService } from '../../../../custumcomponents/codetypes/codetypevalue.service';
import { NgbAddBill } from './addbill.modal';
import { NgbPatientBillsModal } from '../../follow up/counsellingregistry/modal/patientbills.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../../_MasterClasses/BillingClasses';

@Component({
  selector: 'ngbaddbilladv',
  templateUrl: './addbilladv.modal.html',
  styleUrls: ['./addbilladv.modal.scss']
})

export class NgbAddbilladv implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditGuardianInfoRequest: SaveGuardianInfoRequest;
  @Input() ServiceCode: number;
  @Input() ActorCode: number;

  private _type: string;
  @Input()
  get Type(): string {
    return this._type;
  }
  set Type(val: string) {
    this._type = val;
    this.initModalData();
  }

  private _fomattedCode: string;
  @Input()
  get FomattedCode(): string {
    return this._fomattedCode;
  }
  set FomattedCode(val: string) {
    this._fomattedCode = val;
    this.initModalData();
  }

  @Input()
  get FormattedCode(): string {
    return this._fomattedCode;
  }
  set FormattedCode(val: string) {
    this._fomattedCode = val;
    this.initModalData();
  }

  @Input() AdmissionCode2: number;
  @Input() AdmissionCode: string;
  searchTitle: string;
  DateOfBirth: NgbDateStruct;
  public BranchName: string;
  public opadvance: boolean = false;
  public Ipadvance: boolean = false;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  WeddingAn: NgbDateStruct;
  DateOfBirthFemale: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  DateOfBirthMale: NgbDateStruct;
  FemaleDateofBirth: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  TodayDate = new Date();
  public LNetPayable: number;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Individual: boolean = false;
  public modaldisplay: boolean = true;
  public Donor: boolean = false;
  public Couple: boolean = false;

  public AdvanceAmount: number;
  public Categories: boolean = true;

  public SelectedPrescriber: PrescribingDoctor[];
  public SelectedReferral: ReferringDoctor[];
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentSaveIPBillItemsInfoRequest: SaveIPBillItemsInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private modalService: NgbModal, public codeTypeValueService: CodeTypeValueService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.ShowService = false;
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIPBillItemsInfoRequest = new SaveIPBillItemsInfoRequest();
    this.CurrentSaveIPBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadRegistries();
    this.initModalData();
  }

  dataChanged(event: any) {
  }

  initModalData() {
    if (this._type == 'FromProfile') {
      this.opadvance = true;
      this.Ipadvance = false;
      this.Categories = false;
      if (this._fomattedCode) {
        this.LoadPatients(this._fomattedCode);
      }
    }
    else if (this._type == 'IpAdvance') {
      this.opadvance = false;
      this.Ipadvance = true;
      this.Categories = false;
      if (this._fomattedCode) {
        this.LoadPatients(this._fomattedCode);
      }
    }
    try {
      this.cd.markForCheck();
    } catch (e) { }
  }

  individual1() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = true;
    this.Donor = false;
    this.Couple = false;
  }
  donor() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = false;
    this.Donor = true;
    this.Couple = false;
  }
  couple() {
    this.ShowService = true;
    this.Individual = false;
    this.Categories = false;
    this.Donor = false;
    this.Couple = true;
  }
  backtolist() {
    this.ShowService = true;
    this.Categories = true;
    this.Individual = false;
    this.Donor = false;
    this.Couple = false;
  }

  LoadRegistries() {
    this.StartRefreshing();
  }

  onSubmit() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.spinner.hide();
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.spinner.hide();
          this.stopRefreshing();
        }
      }
    );
  }

  onDonor() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 11;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
    );
  }

  onCouple() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingAn));
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.FemaleDateofBirth = new Date(this.parserFormatter.format(this.FemaleDateofBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 30;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
    );
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  PatientsOpadv(Type: string) {
    this.Categories = false;
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.result.then((val: string) => {
      if (Type == 'Opadv') {
        if (val == 'Cross click') {
          this.activeModal.close();
        }
        else if (val != 'Cross click') {
          this.opadvance = true;
          this.Ipadvance = false;
          this.Categories = false;
          this.LoadPatients(val);
        }
      }
      if (Type == 'Ipadv') {
        if (val == 'Cross click') {
          this.activeModal.close();
        }
        else if (val != 'Cross click') {
          this.opadvance = false;
          this.Ipadvance = true;
          this.Categories = false;
          this.LoadPatients(val);
        }
      }
      if (Type == 'opbill') {
        if (val == 'Cross click') {
          this.activeModal.close();
        }
        else if (val != 'Cross click') {
          this.opadvance = false;
          this.Ipadvance = false;
          this.Categories = false;

          const modalRef = this.modalService.open(NgbAddBill,
            {
              centered: true,
              size: "lg",
              backdrop: 'static',
              keyboard: false
            });
          modalRef.componentInstance.FormattedCode = val;
          modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.SelectedPrescriber = receivedEntry.make;
            this.SelectedReferral = receivedEntry.value;
            var ReferDoctor = receivedEntry.RefDoc;
            var ReferDoctorCode = receivedEntry.RefDocCode;
            var Referdesig = receivedEntry.RefDocDes;
            this.router.navigate(['healins/receipt'], { queryParams: { FormattedCodedata: val, PrescriberName: this.SelectedPrescriber[0].DoctorName, PrescriberCode: this.SelectedPrescriber[0].DoctorCode, Prescriberdesignation: this.SelectedPrescriber[0].Designation, RefName: ReferDoctor, RefCode: ReferDoctorCode, Refdesignation: Referdesig } });
          });
          this.activeModal.close();
        }
      }
      if (Type == 'RxBill') {
        if (val == 'Cross click') {
          this.activeModal.close();
        }
        else if (val != 'Cross click') {
          this.opadvance = false;
          this.Ipadvance = false;
          this.Categories = false;
          this.router.navigate(['healins/rxreceipt', { FormattedCodedata: val }]);
          this.activeModal.close();
        }
      }
    });
  }

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  PatientDetails: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;

  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }

  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();

    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          if (this.CurrentPatientInfoByFormattedCodeController && this.CurrentPatientInfoByFormattedCodeController.length > 0) {
            this.PatientDetails = this.CurrentPatientInfoByFormattedCodeController[0];
          }
          this.stopRefreshing();
          this.InitPaymentoptions();
          try {
            this.cd.markForCheck();
            this.cd.detectChanges();
          } catch(e) {}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }
    );
  }

  CurrentCodeTypeRequest: CodeTypeRequest;
  CurrentPaymentDetails: Array<BillPaymentOption>;
  PaymentTypes: CodeTypeValue[];
  InitPaymentoptions() {
    this.CurrentPaymentDetails = new Array<BillPaymentOption>();
    this.CurrentCodeTypeRequest = new CodeTypeRequest();
    this.CurrentCodeTypeRequest.CodeType = "PYTMD";
    this.CurrentCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.GetPaymentTypes(this.CurrentCodeTypeRequest);
  }

  GetPaymentTypes(SendCodeTypeRequest: CodeTypeRequest): void {
    this.StartRefreshing();

    this.codeTypeValueService.GetCodeValuesByType(SendCodeTypeRequest).subscribe
      (
        (result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            this.PaymentTypes = this.ApiResData.Result;
            this.CurrentPaymentDetails = new Array<BillPaymentOption>();
            if (this.PaymentTypes) {
              for (let ptype of this.PaymentTypes) {
                var opt = new BillPaymentOption();
                opt.Amount = 0;
                opt.Charges = 0;
                opt.Details = "";
                opt.PaymentMode = ptype.LongValue;
                opt.Refno = "";
                this.CurrentPaymentDetails.push(opt);
              }
            }
            this.stopRefreshing();
            try {
              this.cd.markForCheck();
              this.cd.detectChanges();
            } catch(e) {}
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              alert(' Failed Due to Internal Error.... Please Contact Admin..');
            }
          }
        },
        (error) => {
          if (error == "401 - Unauthorized") {
            this.stopRefreshing();
          }
          else {
            this.stopRefreshing();
          }
        }
      );
  }

  unchecked(e: any, l: BillPaymentOption) {
    if (!e.target.checked) {
      l.Amount = 0;
      const selectedWithAmount = this.CurrentPaymentDetails.filter((l) => l.Amount && l.IsSelected);
      if (selectedWithAmount.length > 0) {
        this.AdvanceAmount = selectedWithAmount
          .map((l) => +l.Amount)
          .reduce((sum, current) => sum + current, 0);
      } else {
        this.AdvanceAmount = 0;
      }
    }
  }

  netpayablesum(Caution: string) {
    if (Caution == 'add') {
      const selectedWithAmount = this.CurrentPaymentDetails.filter((item) => item.Amount && item.IsSelected);
      if (selectedWithAmount.length > 0) {
        this.AdvanceAmount = selectedWithAmount
          .map((item) => +item.Amount)
          .reduce((sum, current) => sum + current, 0);
      } else {
        this.AdvanceAmount = 0;
      }
    }
  }

  CurrentNewBillData: NewBillData;
  AddData(Type: string) {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.ActorCode;
    this.CurrentNewBillData.BillDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "OP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = this.BranchName;
    this.CurrentNewBillData.ChargeEntryCode = 0;
    this.CurrentNewBillData.Gender = this.PatientDetails.Gender;
    this.CurrentNewBillData.Items = null;
    this.CurrentNewBillData.PrescriberDoctor = null;
    this.CurrentNewBillData.ReferringDoctor = null;
    this.CurrentNewBillData.PatientFormattedCode = this.PatientDetails.FormattedCode;
    this.CurrentNewBillData.PatientName = this.PatientDetails.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.PatientDetails.Telephone1;
    this.CurrentNewBillData.TotalDiscount = 0;
    this.CurrentNewBillData.TotalBill = 0;
    this.CurrentNewBillData.NetPayable = 0;
    this.CurrentNewBillData.AdvanceAmount = this.AdvanceAmount;
    this.CurrentNewBillData.PayOptions = this.CurrentPaymentDetails.filter(
      function (a) {
        return a.IsSelected == true;
      });
    if (Type == 'Ipadv') {
      this.CurrentNewBillData.AdmissionCode = 0;
    }
    this.Caution(Type);
  }

  Caution(Type: string) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {
      this.SaveData(Type);
    }, function (dismiss: any) {
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        );
      }
    });
  }

  SaveData(Type: string) {
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = "0";
    if (Type == 'Opadv') {
      this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 100;
    }
    if (Type == 'Ipadv') {
      this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 200;
    }
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.activeModal.close();
          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }
    );
  }

  AddData2() {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.ActorCode;
    this.CurrentNewBillData.BillDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "IP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = this.BranchName;
    this.CurrentNewBillData.ChargeEntryCode = 0;
    this.CurrentNewBillData.Gender = this.PatientDetails.Gender;
    this.CurrentNewBillData.Items = null;
    this.CurrentNewBillData.PrescriberDoctor = null;
    this.CurrentNewBillData.ReferringDoctor = null;
    this.CurrentNewBillData.PatientFormattedCode = this.PatientDetails.FormattedCode;
    this.CurrentNewBillData.PatientName = this.PatientDetails.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.PatientDetails.Telephone1;
    this.CurrentNewBillData.TotalDiscount = 0;
    this.CurrentNewBillData.TotalBill = 0;
    this.CurrentNewBillData.NetPayable = 0;
    this.CurrentNewBillData.AdvanceAmount = this.AdvanceAmount;
    this.CurrentNewBillData.AdmissionFormattedCode = this.AdmissionCode;
    this.CurrentNewBillData.AdmissionCode = this.AdmissionCode2;
    this.CurrentNewBillData.PayOptions = this.CurrentPaymentDetails.filter(
      function (a) {
        return a.IsSelected == true;
      });

    this.Caution2();
  }

  Caution2() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {
      this.SaveData2();
    }, function (dismiss: any) {
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        );
      }
    });
  }

  SaveData2() {
    this.CurrentSaveIPBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveIPBillItemsInfoRequest.ChargeEntry = "0";
    this.CurrentSaveIPBillItemsInfoRequest.ConditionalOperator = 100;

    this.actorservice.SaveIPBillItemsInfo(this.CurrentSaveIPBillItemsInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.activeModal.close();
          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
      (error) => {
        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }
    );
  }

  AddRefund() {
    this.opadvance = false;
    this.Ipadvance = false;
    this.Categories = false;
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      const modalRef = this.modalService.open(NgbPatientBillsModal,
        {
          centered: true,
          size: "lg",
          backdrop: 'static',
          keyboard: false
        });
      modalRef.componentInstance.ActorCode = val.ActorCode;
      modalRef.result.then((val2: number) => {
        this.router.navigate(['healins/refundreceipt', { FormattedCodedata: val.FormattedCode, ChargeEntryCode: val2 }]);
      });
    });
    this.activeModal.close();
  }

  BackToCat(Type: string) {
    this.Categories = true;
    this.Ipadvance = false;
    this.opadvance = false;
  }
}
